import { combineReducers } from 'redux';

import {
    REQUEST_EBONS_PARTNER,
    RECEIVE_EBONS_PARTNER,
    FAILURE_EBONS_PARTNER,
    REQUEST_LOCK_EBONS,
    RECEIVE_LOCK_EBONS,
    FAILURE_LOCK_EBONS,
    RECEIVE_CHECK_SMS,
    REQUEST_VALIDATE_SMS,
    RECEIVE_VALIDATE_SMS,
    FAILURE_VALIDATE_SMS,
    RECEIVE_CONFIRMATION_SMS,
    REQUEST_CREATE_ORDER,
    RECEIVE_CREATE_ORDER,
    FAILURE_CREATE_ORDER,
    REQUEST_EBONS_FAQ,
    RECEIVE_EBONS_FAQ,
    FAILURE_EBONS_FAQ,
    REQUEST_PARTNERS_EBON,
    RECEIVE_PARTNERS_EBON,
    FAILURE_PARTNERS_EBON,
    REGISTER_CART,
    REQUEST_EBONS_ORDER,
    RECEIVE_EBONS_ORDER,
    FAILURE_EBONS_ORDER,
    RESET_LOCK,
    RESET_CART,
    RESET_ORDER,
    SET_PAYMENT_TYPE_VALUE,
    FAILURE_EBONS_SEO,
    RECEIVE_EBONS_SEO,
    REQUEST_EBONS_SEO
} from './constants';

import { compare, queryEqualLocked } from '../../utils/ebonUtils';

const cart = (state = [], action) => {
    switch (action.type) {
        case REGISTER_CART:
            return action.payload;
        case RESET_CART:
            return [];
        default:
            return state;
    }
};

const ebonPartners = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_PARTNERS_EBON:
            const { payload } = action.response;
            payload.sort(compare);
            return payload;
        default:
            return state;
    }
};

const ebonPartnersFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PARTNERS_EBON:
            return true;
        case RECEIVE_PARTNERS_EBON:
        case FAILURE_PARTNERS_EBON:
            return false;
        default:
            return state;
    }
};

const lock = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_LOCK_EBONS:
            const allLocked = action.response.payload.every(queryEqualLocked);
            return { allLocked: allLocked, ...action.response.payload };
        case RESET_LOCK:
            return [];
        default:
            return state;
    }
};

const lockFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_LOCK_EBONS:
            return true;
        case RECEIVE_LOCK_EBONS:
        case FAILURE_LOCK_EBONS:
        case RESET_LOCK:
            return false;
        default:
            return state;
    }
};

const lockFailure = (state = null, action) => {
    switch (action.type) {
        case REQUEST_LOCK_EBONS:
        case RECEIVE_LOCK_EBONS:
        case RESET_LOCK:
            return null;
        case FAILURE_LOCK_EBONS:
            return {
                response: action.response.message,
                statusCode: action.response.status
            };
        default:
            return state;
    }
};

const tokenSms = (state = '', action) => {
    switch (action.type) {
        case RECEIVE_CHECK_SMS:
            return action.response.payload.token;
        default:
            return state;
    }
};

const validateSmsFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_VALIDATE_SMS:
            return true;
        case RECEIVE_VALIDATE_SMS:
        case FAILURE_VALIDATE_SMS:
            return false;
        default:
            return state;
    }
};

const validateSms = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_VALIDATE_SMS:
            return action.response.payload;
        default:
            return state;
    }
};

const confirmationSms = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_CONFIRMATION_SMS:
            return action.response.status;
        default:
            return state;
    }
};

const createOrderRequest = (state = false, action) => {
    switch (action.type) {
        case REQUEST_CREATE_ORDER:
            return true;
        case RECEIVE_CREATE_ORDER:
        case FAILURE_CREATE_ORDER:
        case RESET_ORDER:
            return false;
        default:
            return state;
    }
};

const createdOrder = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_CREATE_ORDER:
            return { ...action.response.payload, orderState: 'created' };
        case RESET_ORDER:
            return {};
        default:
            return state;
    }
};

const fetchOrder = (state = false, action) => {
    switch (action.type) {
        case REQUEST_EBONS_ORDER:
            return true;
        case RECEIVE_EBONS_ORDER:
        case FAILURE_EBONS_ORDER:
            return false;
        default:
            return state;
    }
};

const confirmedOrder = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_EBONS_ORDER:
            return action.response.payload;
        default:
            return state;
    }
};

const ebons = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_EBONS_PARTNER:
            return action.response.payload;
        default:
            return state;
    }
};

const ebonsFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_EBONS_PARTNER:
            return true;
        case RECEIVE_EBONS_PARTNER:
        case FAILURE_EBONS_PARTNER:
            return false;
        default:
            return state;
    }
};

const faq = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_EBONS_FAQ:
            return action.response.payload;
        default:
            return state;
    }
};

const faqFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_EBONS_FAQ:
            return true;
        case RECEIVE_EBONS_FAQ:
        case FAILURE_EBONS_FAQ:
            return false;
        default:
            return state;
    }
};

const seoFetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_EBONS_SEO:
            return true;
        case RECEIVE_EBONS_SEO:
        case FAILURE_EBONS_SEO:
            return false;
        default:
            return state;
    }
};

const seo = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_EBONS_SEO:
            return action.response.payload;
        default:
            return state;
    }
};

const paymentType = (state = '', action) => {
    switch (action.type) {
        case SET_PAYMENT_TYPE_VALUE:
            return action.paymentType;
        default:
            return state;
    }
};

export default combineReducers({
    ebonPartners,
    ebonPartnersFetching,
    cart,
    ebons,
    ebonsFetching,
    lock,
    tokenSms,
    validateSmsFetching,
    validateSms,
    confirmationSms,
    lockFetching,
    lockFailure,
    createdOrder,
    fetchOrder,
    createOrderRequest,
    confirmedOrder,
    faq,
    paymentType,
    faqFetching,
    seoFetching,
    seo
});



// WEBPACK FOOTER //
// ./src/services/ebon/reducer.js